const svg = `<svg
  class="icon icon-checkmark"
  aria-hidden="true"
  focusable="false"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 12 9"
  fill="none"
  style="width: 13px;"
>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
</svg>`;


class StepWizard extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 0;
  }

  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll("step-item"));
    this.renderTitles();
    document.title = "eSIMリチャージ";

    const urlParams = new URLSearchParams(window.location.search);
    const currentStep = parseInt(urlParams.get("step")) || 1;
    // 默认显示第一步（信息输入）
    this.activateStep(currentStep);
   
    this.setupPopstateListener();
  }
  


  updateInput(qr_code) {
    const box = document.getElementById('manual-wrapper')
    console.log(box, 33333)
    console.log(qr_code, 333)
  }

  generateStepNavItem(step, index) {
    const isCompleted = index < this.currentStep;
    const isActive = index === this.currentStep;

    const stepClass = [
      "desktop-step-nav-item",
      isCompleted ? "desktop-step-nav-item--completed" : "",
      isActive ? "desktop-step-nav-item--active" : "",
    ]
      .filter(Boolean)
      .join(" ");

    return `
      <div class="${stepClass}" data-step-index="${index}">
        <div class="desktop-step-nav-item__number">
          ${isCompleted ? svg : index + 1}
        </div>
        <div class="desktop-step-nav-item__content">
          <div class="desktop-step-nav-item__title">${
            step.getAttribute("title") || `Step ${index + 1}`
          }</div>
        </div>
      </div>
    `;
  }

  renderTitles() {
    const container = document.createElement("div");

    // 桌面端：显示完整的步骤导航条
    container.className = "desktop-steps-navigation";
    this.steps.forEach((step, i) => {
      const stepHtml = this.generateStepNavItem(step, i);
      container.insertAdjacentHTML("beforeend", stepHtml);
    });

    this.insertBefore(container, this.firstChild);
    this.titlesContainer = container;
  }

  setupPopstateListener() {
    // 绑定 popstate 事件处理函数
    this.handlePopstate = (event) => {
      const urlParams = new URLSearchParams(window.location.search);
      const step = parseInt(urlParams.get("step")) || 1;

      // 只更新步骤，不更新 URL（因为 URL 已经改变了）
      this.updateStepFromURL(step);
    };

    // 添加事件监听器
    window.addEventListener("popstate", this.handlePopstate);
  }

  updateStepFromURL(stepNumber) {
    const index = stepNumber - 1;
    if (index < 0 || index >= this.steps.length) return;

    this.currentStep = index;

    this.steps.forEach((step, i) => {
      step.classList.toggle("active", i === index);
    });

    // 重新渲染导航条
    this.titlesContainer.remove();
    this.renderTitles();
    
    // 滚动到页面顶部
    this.scrollToTop();
  }

  activateStep(stepNumber) {
    const index = stepNumber - 1;
    if (index < 0 || index >= this.steps.length) return;

    this.currentStep = index;

    this.steps.forEach((step, i) => {
      step.classList.toggle("active", i === index);
    });

    // 更新 URL 参数
    const url = new URL(window.location);
    url.searchParams.set("step", stepNumber.toString());
    history.pushState({ step: stepNumber }, "", url.toString());

    // 重新渲染导航条
    this.titlesContainer.remove();
    this.renderTitles();
    
    // 滚动到页面顶部
    this.scrollToTop();
  }

  scrollToTop() {
    // 直接滚动到页面顶部
    if (window.innerWidth < 750) {
      window.scrollTo(0, 0);
    }
  }

  disconnectedCallback() {
    // 清理事件监听器
    if (this.handlePopstate) {
      window.removeEventListener("popstate", this.handlePopstate);
    }
  }
}

customElements.define("step-wizard", StepWizard);
customElements.define("step-item", class extends HTMLElement {});
